import { useEffect } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { CARE_SITES } from "@/data/careSites";
import CareNav from "@/components/care/CareNav";
import CareHero from "@/components/care/CareHero";
import Marquee from "@/components/care/Marquee";
import ServicesBento from "@/components/care/ServicesBento";
import Promise from "@/components/care/Promise";
import CareProcess from "@/components/care/CareProcess";
import Scope from "@/components/care/Scope";
import ClientRates from "@/components/care/ClientRates";
import CareContact from "@/components/care/CareContact";
import CareFooter from "@/components/care/CareFooter";

export default function CareLanding() {
  const { pathname } = useLocation();
  const key = pathname.replace(/^\/+/, "").toLowerCase();
  const site = CARE_SITES[key];

  useEffect(() => {
    if (!site) return;
    const prev = document.title;
    document.title = `${site.productName} | ${site.tagline}`;
    return () => {
      document.title = prev;
    };
  }, [site]);

  if (!site) return <Navigate to="/" replace />;

  return (
    <div
      data-testid={`care-landing-${site.key}`}
      className="min-h-screen bg-[#FDFBF7] text-[#1A2621] font-sans-body"
    >
      <CareNav site={site} />
      <CareHero site={site} />
      <Marquee items={site.marquee} ariaLabel={`${site.brand} values marquee`} />
      <ServicesBento site={site} />
      <Promise />
      <CareProcess />
      <Scope site={site} />
      <ClientRates site={site} />
      <CareContact site={site} />
      <CareFooter site={site} />
    </div>
  );
}
